import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, Message, PrimeNGConfig } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { AppComponent } from 'src/app/app.component';
import { ContactosService } from 'src/app/contactos/contactos.service';
import { FAZILService, User, UserService } from 'src/app/core';
import { ResultData, UIService } from 'src/app/core/services/ui.service';
import { Plan } from 'src/app/modelo/Plan';
import { PlanOrganizacion } from 'src/app/modelo/PlanOrganizacion';
import { Subject } from 'src/app/modelo/Subject';
import { SubjectCustomer } from 'src/app/modelo/SubjectCustomer';
import { UsuarioModel } from 'src/app/modelo/usuario.model';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';
import { AdministracionService } from '../../administracion.service';

import { validateDni, validateDNIPattern } from 'src/app/shared/helpers';
import { validateRUC } from 'src/app/shared/helpers';
import { handleDates, validateEmail } from 'src/app/shared/helpers';
import { PerfilService } from 'src/app/perfil/perfil.service';
import * as CryptoJS from 'crypto-js';
import { Organization } from 'src/app/modelo/Organization';
import { TranslateService } from '@ngx-translate/core';
import { DatesService } from 'src/app/core/services/dates.service';
import { RegistroService } from 'src/app/registro/registro.service';

@Component({
    selector: 'app-admin-suscripciones',
    templateUrl: './admin-suscripciones.component.html',
    styleUrls: ['./admin-suscripciones.component.scss']
})
export class AdminSuscripcionesComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    planOrganizaciones: PlanOrganizacion[] = [];
    planOrganizacionesFiltered: PlanOrganizacion[] = [];
    planOrganizacionesSelected: PlanOrganizacion[];
    planOrganizacion: PlanOrganizacion = new PlanOrganizacion();

    //Variables para planes
    planes: Plan[] = [];
    planesFirma: Plan[] = [];
    planesAgendamiento: Plan[] = [];
    planesFiltered: Plan[] = [];

    //Variables para usuarios
    subjectsFiltered: Subject[] = [];
    mostrarPopupSubjects: boolean = false;
    mostrarEditorSubject: boolean = false;
    mostrarFormaPagoSubject: boolean;
    subject: UsuarioModel = new UsuarioModel();
    subjectCode: string;
    subjectCodeValid: boolean = false;
    emailValid: boolean = false;
    searching = false;

    //Variables auxiliares
    cols: any[];
    multiSortMeta = [];
    globalFilterFields = [];
    buttonsActions: any[] = [];
    mostrarEditor: boolean = false;
    minDate: Date;
    maxDate: Date;
    index: number = 0;
    //    acceptTerm: any;
    filtros: any[] = [];

    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    processFilter = false;
    verificando: boolean = false;
    verificandoData: ResultData;
    resultData: ResultData;
    resultDataButtons: any[] = [];
    mostrarResultData: boolean = false;
    ui: UIService;
    dates: DatesService;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private datesService: DatesService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private config: PrimeNGConfig,
        private translateService: TranslateService,
        private administracionService: AdministracionService,
        private contactosService: ContactosService,
        private perfilService: PerfilService,
        private registroService: RegistroService,
    ) {
        this.ui = uiService;
        this.dates = datesService;
        this.cargarDataConstructor();
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.breadcrumbService.setItems([
            { label: 'Suscripciones', routerLink: ['administracion/planesorganizacion'] }
        ]);
        this.cols = [
            //            { field: 'id', header: 'Id', visible: false },
            { field: 'createdOn', header: 'Fecha de Registro', visible: true },
            { field: 'organizacionName', header: 'Organización', visible: true },
            { field: 'organizacionMobileNumber', header: 'Teléfono', visible: true },
            { field: 'organizacionEmail', header: 'Correo electrónico', visible: true },
            { field: 'planName', header: 'Plan', visible: true },
            { field: 'maximoComprobantes', header: 'Nº. Maximo Comprobantes', visible: true, class: 'p-text-right' },
            { field: 'numeroComprobantesEmitidos', header: 'Nº. Comprobantes Emitidos', visible: true, class: 'p-text-right' },
            //            { field: 'minimoComprobantesAlertarRecarga', header: 'Nº. Comprobantes Alerta Recarga', visible: false, class: 'p-text-right' },
            { field: 'planTipoFirmaName', header: 'Plan Firma Electrónica', visible: true, class: 'p-text-right' },
            { field: 'precio', header: 'Precio Total', visible: true, class: 'p-text-right' },
            { field: 'pagado', header: 'Pagado', visible: true, class: 'p-text-center' },
            { field: 'vigente', header: 'Habilitado', visible: true, class: 'p-text-center' }
        ];
        this.multiSortMeta.push({ field: 'createdOn', order: 1 });
        //        this.multiSortMeta.push({ field: 'organizacionName', order: 1 });
        //        this.multiSortMeta.push({ field: 'planName', order: 1 });
        this.globalFilterFields = this.cols.filter((val) => val.visible).map(function(obj) {
            return obj.field;
        });
        this.minDate = this.dates.getDate(this.dates.getDateAddDays( this.ui.getDateNow() , -1 * (360 * 2) ));
        //this.minDate = this.ui.getDateNow();
        this.filtros = this.getFiltros();
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        //        this.planes = await this.administracionService.getPlanesData();
        this.planes = await this.registroService.getPlanesPorTipoPlanData(this.appConfig.properties.tiposPlan.facturacion);
        this.planesFirma = await this.registroService.getPlanesPorTipoPlanData(this.appConfig.properties.tiposPlan.firma);
        this.planesAgendamiento = await this.registroService.getPlanesPorTipoPlanData(this.appConfig.properties.tiposPlan.agendamiento);
        this.planOrganizaciones = await this.administracionService.getPlanesOrganizacionData();
        this.planOrganizacionesFiltered = this.planOrganizaciones.filter((val) => val.pagado == false);
        this.cargandoDataInit = false;
    }

    presentarOpcionesActionSheet(event, planOrganizacion: PlanOrganizacion) {
        this.buttonsActions = [
            {
                text: 'Editar',
                icon: 'pi pi-pencil',
                cssClass: 'p-button-text p-button-info',
                action: this.appConfig.ux.actionsExecute.edit,
                data: planOrganizacion,
                disabled: false
            },
            {
                text: 'Habilitar/Deshabilitar',
                icon: 'pi pi-cog',
                cssClass: 'p-button-text p-button-info',
                action: this.appConfig.ux.actionsExecute.enabled,
                data: planOrganizacion,
                disabled: false
            },
            {
                text: 'Pago de plan',
                icon: 'pi pi-dollar',
                cssClass: 'p-button-text p-button-info',
                action: this.appConfig.ux.actionsExecute.pago,
                data: planOrganizacion,
                disabled: false
            },
            {
                text: 'Eliminar',
                icon: 'pi pi-trash',
                cssClass: 'p-button-text p-button-danger',
                action: this.appConfig.ux.actionsExecute.delete,
                data: planOrganizacion,
                disabled: false
            },

        ];
    }

    async ejecutarAccion(event, accion: string, plo: PlanOrganizacion) {
        this.ui.limpiarMessages();
        switch (accion) {
            case this.appConfig.ux.actionsExecute.edit:
                this.editarPlanOrganizacion(plo);
                break;
            case this.appConfig.ux.actionsExecute.delete:
                this.confirmarEliminarPlanOrganizacion(plo);
                break;
            case this.appConfig.ux.actionsExecute.enabled:
                this.confirmarEstadoPlanOrganizacion(plo);
                break;
            case this.appConfig.ux.actionsExecute.pago:
                this.confirmarPagoPlanOrganizacion(plo);
                break;
        }
    }

    resetVariables(): void {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
        this.planOrganizacion = new PlanOrganizacion();
    }

    async nuevoPlanOrganizacion(): Promise<void> {
        this.resetVariables();
        this.mostrarEditor = true;
    }

    async editarPlanOrganizacion(planOrganizacion: PlanOrganizacion) {
        this.resetVariables();
        this.planOrganizacion = await this.administracionService.getPlanOrganizacionData(planOrganizacion.id);
        handleDates(this.planOrganizacion);
        this.mostrarEditor = true;
    }

    async confirmarPagoPlanOrganizacion(planOrganizacion: PlanOrganizacion) {
        this.resetVariables();
        this.planOrganizacion = await this.administracionService.getPlanOrganizacionData(planOrganizacion.id);
        if (!this.planOrganizacion.pagado) {
            this.planOrganizacion.fechaInicio = new Date();
            this.planOrganizacion.fechaFin = this.ui.getDateMaxByPlan(this.planOrganizacion.fechaInicio, this.planOrganizacion.plan.tipo);
        } else {
            this.planOrganizacion.fechaInicio = new Date(this.planOrganizacion.fechaInicio);
            this.planOrganizacion.fechaFin = new Date(this.planOrganizacion.fechaFin);
        }
        this.mostrarFormaPagoSubject = true;
    }

    guardarDetallePago(): void {
        this.ui.limpiarMessages();
        //Establecer valores UX
        //Guardar planOperacion en persistencia\
        this.planOrganizacion.pagado = true;

        this.administracionService.enviarPlanOrganizacion(this.planOrganizacion).subscribe(
            async (data) => {
                this.mostrarEditor = false;
                this.mostrarFormaPagoSubject = false;
                this.planOrganizaciones = await this.administracionService.getPlanesOrganizacionData();
                this.planOrganizacionesFiltered = this.planOrganizaciones.filter((val) => val.pagado == false);
                this.ui.mostrarMensaje("success", `El plan ${this.planOrganizacion.plan.name} para ${this.planOrganizacion.subject.initials} ha sido registrado con éxito.`);
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    formPrincipalCompleto() {
        return (this.planOrganizacion.plan && this.planOrganizacion.plan.id && this.planOrganizacion.subject && this.planOrganizacion.subject.id);
    }

    guardarPlanOrganizacion(): void {
        this.ui.limpiarMessages();
        if (!this.formPrincipalCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            //Establecer valores UX
            //Guardar planOperacion en persistencia
            this.administracionService.enviarPlanOrganizacion(this.planOrganizacion).subscribe(
                async (data) => {
                    this.mostrarEditor = false;
                    this.planOrganizaciones = await this.administracionService.getPlanesOrganizacionData();
                    this.planOrganizacionesFiltered = this.planOrganizaciones;
                    this.ui.mostrarMensaje("success", `El plan ${this.planOrganizacion.plan.name} para ${this.planOrganizacion.subject.initials} ha sido registrado con éxito.`);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    async confirmarEliminarPlanOrganizacion(planOrganizacion: PlanOrganizacion) {
        this.confirmationService.confirm({
            message: "¿Está seguro de eliminar el plan <strong>" + planOrganizacion.planName + "</strong> para la Organización?. No será posible recuperar la información.",
            accept: () => {
                this.eliminarPlanOrganizacion(planOrganizacion);
            },
        });
    }

    eliminarPlanOrganizacion(planOrganizacion: PlanOrganizacion) {
        this.administracionService.eliminarPlanOrganizacion(planOrganizacion.uuid).subscribe(
            async (data) => {
                this.cargarDataInit();
                this.ui.mostrarMensaje("success", `El plan ${planOrganizacion.planName} ha sido eliminado con éxito.`);
            },
            async (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    async confirmarEstadoPlanOrganizacion(planOrganizacion: PlanOrganizacion) {
        let boolEstado: boolean = planOrganizacion.vigente;
        this.confirmationService.confirm({
            message: "¿Está seguro de <strong>" + (boolEstado ? this.appConfig.ux.actions.disabled : this.appConfig.ux.actions.enabled) + "</strong>"
                + " el plan <strong>" + planOrganizacion.planName + "</strong>"
                + " de  <strong>" + planOrganizacion.organizacionName + "</strong>.",
            accept: () => {
                planOrganizacion.vigente = !boolEstado;
                this.habilitarDeshabilitarPlan(planOrganizacion);
            },
        });
    }

    async habilitarDeshabilitarPlan(planOrganizacion: PlanOrganizacion) {
        this.administracionService.enviarPlanOrganizacion(planOrganizacion).subscribe(
            async (data) => {
                this.mostrarEditor = false;
                this.cargarDataInit();
                this.ui.mostrarMensaje("success", "El plan " + planOrganizacion.planName + " de " + planOrganizacion.organizacionName
                    + " a sido " + (planOrganizacion.vigente ? this.appConfig.ux.status.enabled : this.appConfig.ux.status.disabled) + " con éxito.");
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    resetVariablesSubjects(): void {
        this.ui.limpiarMessages();
        this.mostrarEditorSubject = false;
        this.subject = new UsuarioModel();
    }

    nuevoContacto() {
        this.resetVariablesSubjects();
        this.mostrarEditorSubject = true;
    }


    formSubjectCompleto() {
        return this.subjectCodeValid;
    }

    async guardarContacto() {
        this.ui.limpiarMessages();
        if (!this.formSubjectCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            //Establecer valores UX
            //Guardar subject en persistencia
            this.perfilService.enviarUser(this.subject).subscribe(
                async (data) => {
                    this.planOrganizacion.subject = await this.contactosService.getContactoData(data['code']);
                    this.mostrarEditorSubject = false;
                    this.mostrarPopupSubjects = false;
                    this.ui.mostrarMensaje("success", `${this.planOrganizacion.subject.initials} ha sido registrad@ con éxito.`);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    /**
    ** Métodos de formulario
    **/
    actualizarUmbralAlertasRecargas() {
        this.planOrganizacion.minimoComprobantesAlertarRecarga = this.planOrganizacion.maximoComprobantes * 0.2;
    }

    filteredPlanes(event) {
        this.planesFiltered = this.ui.filteredAutocomplete(this.planes, 'name', event.query);
    }

    filteredPlanesTipoFirma(event) {
        this.planesFiltered = this.ui.filteredAutocomplete(this.planesFirma, 'name', event.query);
    }
    filteredPlanesAgendamiento(event) {
        this.planesFiltered = this.ui.filteredAutocomplete(this.planesAgendamiento, 'name', event.query);
    }

    cargarDataPlan(event) {
        if (event) {
            this.planOrganizacion.planName = this.planOrganizacion.plan.name;
            this.planOrganizacion.precio = this.planOrganizacion.plan.precio;
            this.planOrganizacion.maximoComprobantes = this.planOrganizacion.plan.maximoComprobantes;
            this.planOrganizacion.minimoComprobantesAlertarRecarga = this.planOrganizacion.plan.maximoComprobantes * 0.20;
            this.planOrganizacion.fechaInicio = new Date();
            this.cargarDataPlanFechas(event);
        } else {
            this.planOrganizacion.planName = null;
            this.planOrganizacion.planId = null;
            this.planOrganizacion.precio = 0;
            this.planOrganizacion.maximoComprobantes = 0;
            this.planOrganizacion.minimoComprobantesAlertarRecarga = 0;
            this.planOrganizacion.fechaInicio = new Date();
            this.planOrganizacion.fechaFin = null;
        }
    }

    cargarDataPlanTipoFirma(event) {
        if (event) {
            this.planOrganizacion.planIdTipoFirma = this.planOrganizacion.planTipoFirma.id;
            this.planOrganizacion.planTipoFirmaName = this.planOrganizacion.planTipoFirma.name;
            this.planOrganizacion.planTipoFirmaPrecio = this.planOrganizacion.planTipoFirma.precio;
            this.planOrganizacion.planTipoFirmaFechaInicio = new Date();
            this.cargarDataPlanFechasTipoFirma(event);
        } else {
            this.planOrganizacion.planTipoFirmaName = null;
            this.planOrganizacion.planIdTipoFirma = null;
            this.planOrganizacion.planTipoFirmaPrecio = 0;
            this.planOrganizacion.planTipoFirmaFechaInicio = new Date();
            this.planOrganizacion.planTipoFirmaFechaFin = null;
        }
    }
    cargarDataPlanAgendamiento(event) {
        if (event) {
            this.planOrganizacion.planAgendamientoId = this.planOrganizacion.planAgendamiento.id;
            this.planOrganizacion.planAgendamientoName = this.planOrganizacion.planAgendamiento.name;
            this.planOrganizacion.planAgendamientoPrecio = this.planOrganizacion.planAgendamiento.precio;
            this.planOrganizacion.planAgendamientoFechaInicio = new Date();
            this.cargarDataPlanFechasAgendamiento(event);
        } else {
            this.planOrganizacion.planAgendamientoName = null;
            this.planOrganizacion.planAgendamientoId = null;
            this.planOrganizacion.planAgendamientoPrecio = 0;
            this.planOrganizacion.planAgendamientoFechaInicio = new Date();
            this.planOrganizacion.planTipoFirmaFechaFin = null;
        }
    }

    cargarDataPlanFechas(event) {
        if (this.planOrganizacion && this.planOrganizacion.planTipoFirmaFechaInicio && this.planOrganizacion.planTipoFirma && this.planOrganizacion.planTipoFirma.tipo) {
            this.planOrganizacion.planTipoFirmaFechaFin = this.ui.getDateMaxByPlan(this.planOrganizacion.planTipoFirmaFechaInicio, this.planOrganizacion.planTipoFirma.tipo);
        }
    }
    cargarDataPlanFechasTipoFirma(event) {
        if (this.planOrganizacion && this.planOrganizacion.planTipoFirmaFechaInicio && this.planOrganizacion.planTipoFirma && this.planOrganizacion.planTipoFirma.tipo) {
            this.planOrganizacion.planTipoFirmaFechaFin = this.ui.getDateMaxByPlan(this.planOrganizacion.planTipoFirmaFechaInicio, this.planOrganizacion.planTipoFirma.tipo);
        }
    }
    cargarDataPlanFechasAgendamiento(event) {
        if (this.planOrganizacion && this.planOrganizacion.planAgendamientoFechaInicio && this.planOrganizacion.planAgendamiento && this.planOrganizacion.planAgendamiento.tipo) {
            this.planOrganizacion.planAgendamientoFechaFin = this.ui.getDateMaxByPlan(this.planOrganizacion.planAgendamientoFechaInicio, this.planOrganizacion.planAgendamiento.tipo);
        }
    }

    activePopupSubjects(event, disabled: any) {
        if (!disabled) {
            this.subjectsFiltered = [];
            this.mostrarPopupSubjects = true;
        }
    }

    async filteredSubjectByKeyword(event) {
        this.processFilter = true;
        this.subjectCode = "";
        if (event && event.target && event.target.value) {
            let query = event.target.value.toLocaleLowerCase();
            this.searching = false;
            if (validateDNIPattern(query) && !(query.length > 9 && query.length < 14)) {
                return;
            } else if (validateDNIPattern(query) && query.length > 9 && query.length < 14) {
                this.searching = true;//Es una cédula/ruc
                this.subjectCode = query;
            } else if (!validateDNIPattern(query) && query.length > 3) {
                this.searching = true;//Es un nombre
            }
            if (this.searching) {
                this.subjectsFiltered = await this.contactosService.getSubjectsPorKeywordData(query.trim());
                this.processFilter = false;
            }
        } else {
            this.subjectsFiltered = [];
            this.processFilter = false;
        }
    }

    cargarDataSubject(event) {
        this.ui.limpiarMessages();
        if (event) {
            this.mostrarPopupSubjects = false;
        }
    }

    async searchSubjectPorCode(event) {
        this.ui.limpiarMessages();
        this.subjectCodeValid = false;
        let code: string = this.subjectCode ? this.subjectCode.toString() : "";

        if (!code || code.length == 0) {
            return;
        }

        let isRUC: boolean = false;
        let isCI: boolean = false;

        if (code && code.length == 10) {
            isCI = validateDni(code);
        } else if (code && code.length == 13) {
            isRUC = validateRUC(code);
        }

        if (isCI || isRUC) {

            this.subjectCodeValid = true;

            let msg = "Verificando " + (isCI ? 'CI' : isRUC ? 'RUC' : '') + " Nº. " + code;
            this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
            this.verificando = true;

            //Buscar si existe un usuario con ese code
            let data = await this.administracionService.getUserPorCodeData(code);
            if (data && data['personId']) {
                this.planOrganizacion.subject = await this.contactosService.getContactoData(data['personId']);
                this.ui.mostrarMensaje("info", `¡Bienvenid@ ${this.planOrganizacion.subject.initials} a ${this.appConfig.app.name}!.`);
                this.verificando = false;
                this.mostrarEditorSubject = false;
                this.mostrarPopupSubjects = false;
                this.verificarPlanOrganizacionPorUsuario(this.planOrganizacion.subject.id);
            } else {
                this.subject = new UsuarioModel();
                this.subject.code = this.subjectCode;
                this.verificando = false;
            }
        } else {
            this.subject = new UsuarioModel();
            this.verificando = false;
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.cirucCustomerInvalid}`);
        }

    }

    async verificarPlanOrganizacionPorUsuario(usuarioId) {
        if (usuarioId) {
            let organizationUser: Organization = await this.perfilService.getUserOrganizationPorUsuarioData(usuarioId);
            let planOrganizacionExist: PlanOrganizacion = this.planOrganizaciones.find((item) => item.organizacionId == organizationUser.id);
            if (planOrganizacionExist && planOrganizacionExist.id) {
                this.planOrganizacion = planOrganizacionExist;
            }
        }

    }

    async searchEmailByCode(event) {
        this.ui.limpiarMessages();
        this.emailValid = false;
        let code: string = this.subject.email ? this.subject.email : "";

        if (!code || code.length == 0) {
            return;
        }

        let msg = "Verificando email " + code;
        this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
        this.verificando = true;

        if (code) {
            let emailExistente = false;

            this.emailValid = validateEmail(code);

            if (this.emailValid) {
                emailExistente = await this.administracionService.getEmailPorCodeData(code);
                this.verificando = false;
            } else {
                this.verificando = false;
                this.ui.mostrarMensaje("error", this.appConfig.validationMsgs.emailPattern);
                return;
            }
            if (emailExistente) {
                this.ui.mostrarMensaje("warn", `El correo electrónico ya se encuentra registrado.`);
            }
        } else {
            this.verificando = false;
        }
    }

    filtrar(event, key: string) {
        if (event && event.value) {
            let option = event.value;
            switch (key) {
                case 'filterActivo':
                    this.planOrganizacionesFiltered = this.planOrganizaciones.filter((val) => val.pagado == option['value']);
                    break;
                default:
                    break;
            }
        } else {
            this.planOrganizacionesFiltered = this.planOrganizaciones.filter((val) => val.pagado == false);
            this.filtros = this.getFiltros();
        }
    }

    getFiltros() {
        return [
            {
                name: 'Filtrar por Tipo',
                value: [
                    { name: 'Vigentes', value: true },
                    { name: 'Solicitudes', value: false },
                ],
                key: 'filterActivo',
            }
        ]
    }

}
